import styled, { css } from "styled-components";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledTooltip = styled.div<{ $isLight: boolean }>`
  ${BoxSizingStyle}
  ${FontStyle}

  max-width: 200px;
  border-radius: 8px;
  padding: 4px 10px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.9);
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  color: #fff;
  margin: 4px;

  ${(props) =>
    props.$isLight &&
    css`
      background-color: var(--page-paper-main);
      box-shadow: var(--shadow-secondary);
      color: var(--color-theme-700);
    `}
`;
